export interface ILikeProducts {
    isLoading: boolean;
    likeProductsList: any[];
    error: string;
}

export type State = ILikeProducts;

export type ILikeProductsStateAndAction = State & Action;

export type Action = {
    getLikeProduct: (id: number) => Promise<void>;
};

export const initialState: State = {
    isLoading: false,
    likeProductsList: [],
    error: "",
};
